/**
 * @NOTICE this is a temp hack / fix to cap the number of points earned for the le_tour product type
 */
export const LOYALTY_TOUR_CAPPED_EARN_POINTS_TOTAL = 140_000

/**
 * @NOTICE this is a temp hack / fix to cap the number of status credits earned for the le_tour product type
 */
export const LOYALTY_TOUR_CAPPED_EARN_STATUS_CREDITS_TOTAL = 650

/**
 * @dev temporary campaign for earn key for hotel LPC Ultra Lux
 */
export const LOYALTY_ULTRA_LUX_CAMPAIGN_EARN_KEY = 'PT=tactical_ao_hotel&C=ultraLux'

/**
 * @dev earn key for flights Gardua bonus points campaign
 */
export const LOYALTY_GARUDA_BONUS_POINTS_CAMPAIGN_EARN_KEY = 'c=GarudaTriplePoints'
